"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseType = exports.FormEncoding = exports.FormData = exports.Headers = exports.Patch = exports.Delete = exports.Put = exports.Post = exports.Get = void 0;
var index_1 = require("./index");
function Get(url, appendQuery) {
    if (typeof appendQuery === 'undefined') {
        appendQuery = false;
    }
    return (0, index_1.methodDecoratorFactory)('GET', url, false, appendQuery);
}
exports.Get = Get;
function Post(url, appendQuery) {
    if (appendQuery === void 0) { appendQuery = false; }
    return (0, index_1.methodDecoratorFactory)('POST', url, true, appendQuery);
}
exports.Post = Post;
function Put(url, appendQuery) {
    if (appendQuery === void 0) { appendQuery = false; }
    return (0, index_1.methodDecoratorFactory)('PUT', url, true, appendQuery);
}
exports.Put = Put;
function Delete(url, sendBody, appendQuery) {
    if (sendBody === void 0) { sendBody = false; }
    if (appendQuery === void 0) { appendQuery = false; }
    return (0, index_1.methodDecoratorFactory)('DELETE', url, sendBody, appendQuery);
}
exports.Delete = Delete;
function Patch(url) {
    return (0, index_1.methodDecoratorFactory)('PATCH', url, true, false);
}
exports.Patch = Patch;
function Headers(headers) {
    return (0, index_1.headerDecoratorFactory)(headers);
}
exports.Headers = Headers;
function FormData(name) {
    return function (target, property, parameter) {
        if (!target.__pretend_parameter__) {
            Object.defineProperty(target, '__pretend_parameter__', {
                enumerable: false,
                value: {}
            });
        }
        if (!target.__pretend_parameter__[property]) {
            target.__pretend_parameter__[property] = [];
        }
        target.__pretend_parameter__[property].push({
            type: 'FormData',
            name: name,
            parameter: parameter
        });
    };
}
exports.FormData = FormData;
function FormEncoding(target, property, parameter) {
    if (!target.__pretend_parameter__) {
        Object.defineProperty(target, '__pretend_parameter__', {
            enumerable: false,
            value: {}
        });
    }
    if (!target.__pretend_parameter__[property]) {
        target.__pretend_parameter__[property] = [];
    }
    target.__pretend_parameter__[property].push({
        type: 'FormEncoding',
        parameter: parameter
    });
}
exports.FormEncoding = FormEncoding;
function ResponseType(type, transform) {
    if (transform === void 0) { transform = function (data) { return [data]; }; }
    return (0, index_1.resourceTypeDecoratorFactory)(type, transform);
}
exports.ResponseType = ResponseType;
//# sourceMappingURL=decorators.js.map